<template>
  <v-container
    id="painelfluxocaixa"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <dashboard-filtro-datas
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
          />
          <v-row v-if="enableBtnPrint">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="text-left"
            >
              <v-btn
                class="col-6 col-sm-6 col-md-1 col-lg-1"
                small
                :color="corPrimaria"
                dark
                :loading="loadingPrint"
                @click="imprimir()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Imprimir
              </v-btn>
            </v-col>
          </v-row>
          <v-row id="componeteSaldoDisponivel">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="5"
            >
              <v-container>
                <v-card
                  id="cardDashbord"
                  class="mx-auto"
                  outlined
                >
                  <div class="card-header-dashbord">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="10"
                        md="10"
                        lg="10"
                        class="d-flex flex-wrap"
                      >
                        Qual seu saldo bancário disponível?
                      </v-col>
                      <v-col
                        cols="12"
                        sm="2"
                        md="2"
                        lg="2"
                        class="d-flex justify-end"
                      >
                        <v-tooltip
                          top
                          max-width="400"
                          width="400"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              id="iconInformationFatxMetaComercial4"
                              class="text-left"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="enableTexto('195')"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <div
                            v-if="!carregandoTooltip"
                            v-html="textoOrientacao"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </div>
                  <v-card-actions>
                    <v-row>
                      <v-col
                        id="saldoTotalId"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        class="text-right"
                      >
                        <h1
                          v-if="enableTextoSaldo"
                          id="textoSaldo"
                          :style="styleSaldoBancario"
                          class="text-center"
                        >
                          Saldo Disponível
                        </h1>
                        <show-saldo-total-fluxo-caixa />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <show-saldo-contas-fluxo-caixa id="tabelaContaId" />
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="7"
            >
              <v-row id="projecaoFinanceira">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="8"
                >
                  <v-container>
                    <dashoard-card-view
                      :exibir-texto-titulo="true"
                      :code-information="'196'"
                      :text="'Qual a projeção financeira para os próximos 30 dias?'"
                      :texto-information="textoProjecaoFinanceira"
                      :style-object="styleSaldoBancario"
                      :componente-grafico="true"
                      :grafico-id="'myChart17'"
                      :dados-grafico="chartFluxoCaixa"
                      :titulo-id="'myChart17'"
                      :exibir-legenda="true"
                      :padding="dynamicPaddingFluxoVenda2"
                      :loading="loadingGraficoProjecaoFinanceira"
                    />
                  </v-container>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="4"
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <dashoard-card-view
                          :exibir-texto-titulo="true"
                          :text="'Em 7 dias'"
                          :exibir-informacao="false"
                          :style-object="styleSaldoBancarioValor[7]"
                          :componente-valor="true"
                          :valor="valor7Dias"
                          :padding="dynamicPaddingFluxoVenda3"
                          :loading="loadingProjecaoFinanceira7Dias"
                        />
                      </v-col>
                      <v-col
                        id="componenteValorDias"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <dashoard-card-view
                          :exibir-texto-titulo="true"
                          :text="'Em 15 dias'"
                          :exibir-informacao="false"
                          :style-object="styleSaldoBancarioValor[15]"
                          :componente-valor="true"
                          :valor="valor15Dias"
                          :padding="dynamicPaddingFluxoVenda3"
                          :loading="loadingProjecaoFinanceira15Dias"
                        />
                      </v-col>
                      <v-col
                        id="componenteValorDias"
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                      >
                        <dashoard-card-view
                          :exibir-texto-titulo="true"
                          :text="'Em 30 dias'"
                          :exibir-informacao="false"
                          :style-object="styleSaldoBancarioValor[30]"
                          :componente-valor="true"
                          :valor="valor30Dias"
                          :padding="dynamicPaddingFluxoVenda3"
                          :loading="loadingProjecaoFinanceira30Dias"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="componenteReceberPagar">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <v-row id="valoresReceber">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="7"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'197'"
                    :text="'A receber nos próximos 30 dias?'"
                    :texto-information="textoReceber"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorReceber30"
                    :padding="dynamicPaddingFluxoVenda4"
                    :loading="loadingProjecaoReceber30Dias"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="5"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoard-card-view
                        :exibir-texto-titulo="true"
                        :text="'Em 7 dias'"
                        :exibir-informacao="false"
                        :style-object="styleProjecaoReceberDias"
                        :componente-valor="true"
                        :valor="valorReceber7Dias"
                        :padding="dynamicPaddingFluxoVenda5"
                        :loading="loadingProjecaoReceber7Dias"
                      />
                    </v-col>
                    <v-col
                      id="componenteValorDias"
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoard-card-view
                        :exibir-texto-titulo="true"
                        :text="'Em 15 dias'"
                        :exibir-informacao="false"
                        :style-object="styleProjecaoReceberDias"
                        :componente-valor="true"
                        :valor="valorReceber15Dias"
                        :padding="dynamicPaddingFluxoVenda5"
                        :loading="loadingProjecaoReceber15Dias"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <v-row id="valoresPagar">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="7"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'198'"
                    :text="'A pagar nos próximos 30 dias?'"
                    :texto-information="textoPagar"
                    :style-object="styleProjecaoPagar"
                    :componente-valor="true"
                    :valor="valorPagar30"
                    :padding="dynamicPaddingFluxoVenda4"
                    :loading="loadingProjecaoPagar30Dias"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="5"
                >
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoard-card-view
                        :exibir-texto-titulo="true"
                        :text="'Em 7 dias'"
                        :exibir-informacao="false"
                        :style-object="styleProjecaoReceberDias"
                        :componente-valor="true"
                        :valor="valorPagar7Dias"
                        :padding="dynamicPaddingFluxoVenda5"
                        :loading="loadingProjecaoPagar7Dias"
                      />
                    </v-col>
                    <v-col
                      id="componenteValorDias"
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashoard-card-view
                        :exibir-texto-titulo="true"
                        :text="'Em 15 dias'"
                        :exibir-informacao="false"
                        :style-object="styleProjecaoReceberDias"
                        :componente-valor="true"
                        :valor="valorPagar15Dias"
                        :padding="dynamicPaddingFluxoVenda5"
                        :loading="loadingProjecaoPagar15Dias"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="movimentacaoFinanceira">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Qual minha movimentação para os próximos 30 dias?
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationFatxMetaComercial4"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('199')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      id="idMovimentacaoFinanceira"
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-projecao-dados-movimentacao-fluxo-caixa />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import FluxoCaixa from '../../../../services/fluxocaixa'
  import Chart from 'chart.js'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFluxoCaixa',
    emits: ['updateFluxo', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../components/core/FiltroDatas'),
      DashoardCardView: () => import('../../components/core/CardView'),
      ShowSaldoTotalFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa/FluxoCaixaSaldoTotal'),
      ShowSaldoContasFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa/FluxoCaixaSaldoContas'),
      ShowProjecaoDadosMovimentacaoFluxoCaixa: () => import('../../components/financeiro/fluxoCaixa/FluxoCaixaProjecaoDadosMovimentacao'),
    },
    mixins: [utils],
    data: () => ({
      attrs: '',
      on: '',
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleSaldoBancario: {
        color: '#4CAF50',
      },
      styleProjecaoReceberDias: {
        color: '#7c7673',
      },
      styleSaldoBancarioValor: {
        7: { color: '#4CAF50' },
        15: { color: '#4CAF50' },
        30: { color: '#4CAF50' },
      },
      styleProjecaoPagar: {
        color: '#f27686',
      },
      usuarioIdentificado: false,
      paginaEnable: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enablePrimeiroDia: false,
      enableUltimoDia: false,
      enableEmpresa: true,
      link: window.location.href,
      permissaoFluxoCaixa: '',
      select: [],
      codigo: 0,
      orientacao: [],
      codigoId: ['195', '196', '197', '198', '199'],
      textoSaldoBancario: '',
      textoProjecaoFinanceira: '',
      textoReceber: '',
      textoPagar: '',
      textoMovimentacao: '',
      chartFluxoCaixa: {},
      valor7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valor15Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valor30Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber30: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorReceber15Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar30: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar7Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorPagar15Dias: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      dynamicPaddingFluxoVenda1: '',
      dynamicPaddingFluxoVenda2: '',
      dynamicPaddingFluxoVenda3: '',
      dynamicPaddingFluxoVenda4: '',
      dynamicPaddingFluxoVenda5: '',
      dynamicPaddingFluxoVenda6: '',
      enableBtnPrint: false,
      enableTextoSaldo: false,
      headersContaBancaria: [
        { text: 'Conta Corrente', value: 'desc_conta', width: '200px', class: 'black--text title' },
        { text: 'Saldo Atual', value: 'saldo', width: '200px', align: 'right', class: 'black--text title' },
      ],
      contasBancarias: [],
      headersMovimentacao: [
        { text: 'Período', value: 'periodo', width: '10%', align: 'center', class: 'black--text title' },
        { text: 'Saldo Inicial', value: 'saldo_inicial', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Receber', value: 'receber', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'A Pagar', value: 'pagar', width: '20%', align: 'right', class: 'black--text title' },
        { text: 'Saldo Projeto', value: 'saldo_projetado', width: '20%', align: 'right', class: 'black--text title' },
      ],
      dadosMovimentacao: [],
      loadingPrint: false,
      loadingGraficoProjecaoFinanceira: false,
      loadingProjecaoFinanceira7Dias: false,
      loadingProjecaoFinanceira15Dias: false,
      loadingProjecaoFinanceira30Dias: false,
      loadingProjecaoReceber30Dias: false,
      loadingProjecaoReceber7Dias: false,
      loadingProjecaoReceber15Dias: false,
      loadingProjecaoPagar30Dias: false,
      loadingProjecaoPagar7Dias: false,
      loadingProjecaoPagar15Dias: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.primeiroDia)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)

      eventEmit.$on('update-dados-saldo-contas', this.handleDadosSaldoContas)

      eventEmit.$on('update-movimentacao-contas', this.handleDadosMovimentacaoContas)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)

      eventEmit.$off('update-dados-saldo-contas', this.handleDadosSaldoContas)

      eventEmit.$off('update-movimentacao-contas', this.handleDadosMovimentacaoContas)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Fluxo de Caixa')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 31rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 20rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 14rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 17rem !important'

          this.dynamicPaddingFluxoVenda5 = 'padding-right: 17rem !important'

          this.dynamicPaddingFluxoVenda6 = 'padding-right: 100rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 12rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 6rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 4rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda5 = 'padding-right: 7rem !important'

          this.dynamicPaddingFluxoVenda6 = 'padding-right: 60rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 680) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda5 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda6 = 'padding-right: 11rem !important'
        } else if (window.innerWidth > 681 && window.innerWidth < 1080) {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 25rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 25rem !important'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 25rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 25rem !important'

          this.dynamicPaddingFluxoVenda5 = 'padding-right: 25rem !important'

          this.dynamicPaddingFluxoVenda6 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingFluxoVenda1 = 'padding-right: 9rem !important'

          this.dynamicPaddingFluxoVenda2 = 'padding-right: 2rem !important; margin: -1rem 0 0 -1rem;'

          this.dynamicPaddingFluxoVenda3 = 'padding-right: 3rem !important'

          this.dynamicPaddingFluxoVenda4 = 'padding-right: 3rem !important; margin: -1rem 0 0 -1rem;'

          this.dynamicPaddingFluxoVenda5 = 'padding-right: 5rem !important'

          this.dynamicPaddingFluxoVenda6 = 'padding-right: 54rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.select = select

        this.updateDate()
      },

      handleDadosSaldoContas (contas) {
        this.contasBancarias = contas
      },

      handleDadosMovimentacaoContas (dados) {
        this.dadosMovimentacao = dados
      },

      styleSaldo (value, dias) {
        this.styleSaldoBancarioValor[dias] = {
          color: value < 0 ? '#f27686' : '#4CAF50',
        }
      },

      async updateDate () {
        this.contasBancarias = []
        this.dadosMovimentacao = []

        eventEmit.$emit('update-fluxo', this.select)

        this.valor7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valor15Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valor30Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber30 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorReceber15Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar30 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar7Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorPagar15Dias = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        if (this.chartFluxoCaixa.data) {
          this.chartFluxoCaixa.destroy()
        }

        this.styleSaldoBancarioValor = {
          7: { color: '#4CAF50' },
          15: { color: '#4CAF50' },
          30: { color: '#4CAF50' },
        }

        this.loadingGraficoProjecaoFinanceira = true
        this.loadingProjecaoFinanceira7Dias = true
        this.loadingProjecaoFinanceira15Dias = true
        this.loadingProjecaoFinanceira30Dias = true
        this.loadingProjecaoReceber30Dias = true
        this.loadingProjecaoReceber7Dias = true
        this.loadingProjecaoReceber15Dias = true
        this.loadingProjecaoPagar30Dias = true
        this.loadingProjecaoPagar7Dias = true
        this.loadingProjecaoPagar15Dias = true

        await FluxoCaixa.showProjecaoFinanceira7Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valor7Dias = resposta.data.projecaoSeteDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo(resposta.data.projecaoSeteDias, 7)
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text
            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoFinanceira7Dias = false })

        await FluxoCaixa.showProjecaoFinanceira15Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valor15Dias = resposta.data.projecaoQuinzeDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo(resposta.data.projecaoQuinzeDias, 15)
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text
            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text
            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoFinanceira15Dias = false })

        FluxoCaixa.showProjecaoFinanceira30Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valor30Dias = resposta.data.projecaoTrintaDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.styleSaldo(resposta.data.projecaoTrintaDias, 30)
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoFinanceira30Dias = false })

        await FluxoCaixa.showProjecaoReceber30Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber30 = resposta.data.projecaoReceberTrintaDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoReceber30Dias = false })

        await FluxoCaixa.showProjecaoReceber7Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber7Dias = resposta.data.projecaoReceberSeteDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoReceber7Dias = false })

        await FluxoCaixa.showProjecaoReceber15Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorReceber15Dias = resposta.data.projecaoReceberQuinzeDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoReceber15Dias = false })

        await FluxoCaixa.showProjecaoPagar30Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorPagar30 = resposta.data.projecaoPagarTrintaDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoPagar30Dias = false })

        await FluxoCaixa.showProjecaoPagar7Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorPagar7Dias = resposta.data.projecaoPagarSeteDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoPagar7Dias = false })

        await FluxoCaixa.showProjecaoPagar15Dias(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            this.valorPagar15Dias = resposta.data.projecaoPagarQuinzeDias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Usuario nao encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Contrato não encontrado') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingProjecaoPagar15Dias = false })

        await FluxoCaixa.showGraficoProjecaoFinanceira(localStorage.username, localStorage.tokencontrato, this.select).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('myChart17').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            this.chartFluxoCaixa = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.data,
                datasets: [
                  {
                    label: 'Projeção Financeira',
                    data: resposta.data.valorReceber,
                    backgroundColor: resposta.data.cores,
                    order: 1,
                    tension: 0,
                    pointRadius: 0.7,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      callback: function (label) {
                        return label.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      },
                    },
                    display: mobile,
                  }],
                },
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    mode: 'label',
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                  },
                },
              },
            })
          } else if (resposta.data.text === 'Não há dados para exibição do gráfico') {
            this.text = resposta.data.text
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingGraficoProjecaoFinanceira = false })

        this.enableBtnPrint = true
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.loadingPrint = true
          this.enableTextoSaldo = true

          await this.executarImpressao()
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        } finally {
          this.loadingPrint = false
        }
      },

      async executarImpressao () {
        return new Promise(resolve => {
          setTimeout(() => {
            this.print()

            resolve()
          }, 3000)
        })
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 20, posY)
            posY += pdf.getTextDimensions(title).h /* + 5 */

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            if (title !== 'E os que mais estão caindo?') {
              await pdf.addPage()
            }

            posY = 20

            return posY
          }

          // Definir a margem esquerda
          let posYFiltros = 10
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16

          // Adicionar saldo bancario
          const saldoTotal = document.getElementById('saldoTotalId')
          const canvas = await html2canvas(saldoTotal)
          const imgWidth = 180
          const imgHeight = (canvas.height * imgWidth) / canvas.width

          pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidth, imgHeight)
          posYFiltros += imgHeight/*  + 5 */

          // Adicionar a tabela "Quais meus clientes que não compraram no mês?"
          const titleTableSaldo = 'Qual seu saldo bancário disponível?'
          const tableSaldoBancario = this.contasBancarias.map(item => [item.desc_conta, item.saldo])
          posYFiltros = await addTable(tableSaldoBancario, this.headersContaBancaria, titleTableSaldo, posYFiltros, 8)

          // Adiciona projeção financeira
          const projecaoFinanceira = document.getElementById('projecaoFinanceira')
          const canvasProjecaoFinanceira = await html2canvas(projecaoFinanceira)
          const imgWidthProjecaoFinanceira = 180
          const imgHeightProjecaoFInanceira = (canvasProjecaoFinanceira.height * imgWidthProjecaoFinanceira) / canvasProjecaoFinanceira.width

          pdf.addImage(canvasProjecaoFinanceira.toDataURL('image/png'), 'PNG', 70 + marginLeftPx, posYFiltros, imgWidthProjecaoFinanceira, imgHeightProjecaoFInanceira)
          posYFiltros += imgHeightProjecaoFInanceira

          // Adiciona contas a receber e pagar
          const componenteReceberPagar = document.getElementById('componenteReceberPagar')
          const canvasComponenteReceberPagar = await html2canvas(componenteReceberPagar)
          const imgWidthcanvasComponenteReceberPagar = 290
          const imgHeightcanvasComponenteReceberPagar = (canvasComponenteReceberPagar.height * imgWidthProjecaoFinanceira) / canvasComponenteReceberPagar.width

          pdf.addImage(canvasComponenteReceberPagar.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthcanvasComponenteReceberPagar, imgHeightcanvasComponenteReceberPagar)
          posYFiltros += imgHeightcanvasComponenteReceberPagar

          // Adiciona tabela movimentação financeira
          pdf.addPage()
          posYFiltros = 10

          const titleTableMovimentacao = 'Qual minha movimentação para os próximos 30 dias?'
          const tableTableMovimentacao = this.dadosMovimentacao.map(item => [item.periodo, item.saldo_inicial, item.receber, item.pagar, item.saldo_projetado])
          posYFiltros = await addTable(tableTableMovimentacao, this.headersMovimentacao, titleTableMovimentacao, posYFiltros, 8)

          // Salvar o PDF
          pdf.save('relatorio_fluxo_caixa.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.loadingPrint = false
          this.loadingBtnPrint = true
          this.enableTextoSaldo = false
        }
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #painelfluxocaixa {
      margin: 0 0 0 -1rem;
    }

    #idMovimentacaoFinanceira {
      margin: 0 0 0 -1rem;
      width: 115%;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      align-items: center;
      height: 100px;
    }

    #textoReceber7Dias {
      font-size: 12px;
      display: grid;
      align-items: center;
      margin: -1rem 0 0 12rem;
      font-weight: bold;
    }

    #textoReceber15Dias {
      font-size: 12px;
      display: grid;
      align-items: center;
      margin: -1rem 0 2.5rem 12rem;
      font-weight: bold;
    }

    #saldoDisponivel {
      font-size: 14px;
      display: flex;
      margin: -4rem 0 0 -1rem;
    }

    #iconInformationGraficoProjecao {
      margin: 0 0 0 -0.7rem;
    }

    #texto7Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -0.8rem 0 0 12rem;
      font-weight: bold;
    }

    #texto15Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -0.8rem 0 0 12rem;
      font-weight: bold;
    }

    #texto30Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -0.8rem 0 0 12rem;
      font-weight: bold;
    }

    #DividirBloco1 {
      margin: 1rem auto;
    }

    #DividirBloco2 {
      margin: 1rem auto;
    }

    #iconInformationProjecaoFinanceira {
      margin: 0 0 0 -1rem;
    }

    #projecaoFinanceira30Dias {
      margin: -1.5rem 0 0 -1.5rem;
    }

    #componeteSaldoDisponivel{
      max-width: 103%;
    }

    #componenteReceberPagar{
      max-width: 97%;
    }

    #movimentacaoFinanceira{
      max-width: 97%;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #textoReceber7Dias {
      font-size: 12px;
      display: grid;
      align-items: center;
      margin: -10rem 0 0 38.5rem;
      font-weight: bold;
    }

    #textoReceber15Dias {
      font-size: 12px;
      display: grid;
      align-items: center;
      margin: -4rem 0 0 38.5rem;
      font-weight: bold;
    }

    #iconInformationGraficoProjecao {
      margin: 0 0 0 -0.7rem;
    }

    #texto7Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -0.8rem 0 0 7rem;
      font-weight: bold;
    }

    #texto15Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -10.5rem 0 0 29.5rem;
      font-weight: bold;
    }

    #texto30Dias {
      font-size: 14px;
      display: grid;
      align-items: center;
      margin: -19.5rem 0 0 49rem;
      font-weight: bold;
    }

    #DividirBloco1 {
      margin: -10rem auto;
    }

    #DividirBloco2 {
      margin: 1rem auto;
    }

    #iconInformationProjecaoFinanceira {
      margin: 0 0 0 -1rem;
    }

    #projecaoFinanceira30Dias {
      margin: 0 0 0 -1rem;
    }

    #iconProjecaoFinanceira30Dias {
      margin: -1.5rem 0 0 -1.5rem;
    }
  }
</style>

<style lang="sass">
  #desc_conta
    font-size: 11px

  #saldoConta
    font-size: 11px

  #texto7Dias
    font-size: 14px
    display: grid
    align-items: center
    margin: -0.5rem 0 0 8rem
    font-weight: bold

  #texto15Dias
    font-size: 14px
    display: grid
    align-items: center
    margin: -0.5rem 0 0 8rem
    font-weight: bold

  #texto30Dias
    font-size: 14px
    display: grid
    align-items: center
    margin: -0.5rem 0 0 8rem
    font-weight: bold

  #textoReceber7Dias
    font-size: 12px
    display: grid
    align-items: center
    margin: -0.3rem 0 0 -0.5rem
    font-weight: bold

  #textoReceber15Dias
    font-size: 12px
    display: grid
    align-items: center
    margin: -0.3rem 0 0 -0.5rem
    font-weight: bold

  #formaterDados
    font-size: 11px

  .container
    max-width: 100%

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFluxoCaixa
    margin: -2rem 0 0 -1rem

  #componenteValorDias
    margin: -3rem 0 0 0

  #componenteReceberPagar
    margin: -2rem 0 0 0

  #movimentacaoFinanceira
    margin: -2rem 0 0 0

  #listItemMovimentacao
    margin: -2rem 0 0 -1rem

  #textoSaldo
    margin: 0 0 -2rem 31rem
    font-size: 33px

</style>
